import {fromJS} from 'immutable';
import {combineReducers} from 'redux-immutable';
import {
    localization,
    bootstrap as bootstrapLocalization
} from 'epic-localization/src/client/reducers/localization.reducer';
import config from './config.reducer';
import news from './news.reducer';
import user from './user.reducer';
import overview from './overview.reducer';
import influencer from './influencer.reducer';
import settings from './settings.reducer';
import nav from './nav.reducer';
import dashboard from './dashboard.reducer';
import eula from './eula.reducer';
import error from './error.reducer';
import payout from './payout.reducer';
import tax from './tax.reducer';

import 'epic-diesel-common/src/redux'; // Common reducers

const reducers = {
    localization,
    news,
    user,
    overview,
    influencer,
    settings,
    nav,
    dashboard,
    config,
    eula,
    error,
    payout,
    tax
};
const bootstrapReducers = [bootstrapLocalization];

export function bootstrap(dataPreload, pluginBootstraps) {
    let bootstrapState = fromJS({});
    for (const bootstrapReducer of bootstrapReducers) {
        bootstrapState = bootstrapState.merge(bootstrapReducer(dataPreload));
    }
    bootstrapState = bootstrapState.merge({
        news: dataPreload.news,
        user: dataPreload.user,
        overview: dataPreload.overview,
        config: dataPreload.config,
        influencer: dataPreload.influencer
    });
    if (pluginBootstraps) {
        // Use boostraps from plugin registry
        for (const pluginBootstrap of pluginBootstraps) {
            if (pluginBootstrap.bootstrap) {
                bootstrapState = bootstrapState.merge(pluginBootstrap.bootstrap(dataPreload));
            }
        }
    }
    return bootstrapState;
}

export function createReducer(extraReducers) {
    return combineReducers({
        ...reducers,
        ...extraReducers
    });
}
